<div class="car-detail__header-left">
  <div class="car-detail__header-left-content">
    <ng-content></ng-content>
  </div>
  <div class="car-detail__header-left-stickers">
    @if (inStock) {
      @if (branchId === undefined || branchId === 356) {
        <app-sticker [color]="'primary'">{{ 'globals.inStock' | translate }}</app-sticker>
      } @else {
        <app-sticker [color]="'primary'">{{ 'globals.delivery24hours' | translate }}</app-sticker>
      }
    } @else {
      <app-sticker>{{ 'globals.comingSoon' | translate }}</app-sticker>
    }
  </div>
</div>
